module.exports = __webpack_public_path__ + "img/sns_facebook.e4da2370.png";